// src\main.ts
/// <reference types="@angular/localize" />
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { defineCustomElements } from '@ionic/core/loader';

if (environment.production) {
  enableProdMode();
}

// 👇 IMPORT DINÂMICO (CRÍTICO para evitar quebra no iOS)
// if (typeof window !== 'undefined') {
//   import('vconsole').then(({ default: VConsole }) => {
//     new VConsole();
//   });
// }

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));

// Inicializa os Web Components do Ionic
defineCustomElements(window);
